module.exports = __webpack_public_path__ + "static/fonts/UnidreamLED.67a845af.eot";